import { suspend } from 'suspend-react';
import library from './library';

export default function useAssets(keys) {
  return suspend(() => new Promise(resolve => {
    if (library.has(keys)) return resolve(library.fulfill(keys));

    const dispose = library.onChange(() => {
      if (!library.has(keys)) return;
      dispose();
      resolve(library.fulfill(keys));
    });
  }), keys);
};